
let HospitalDept = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient;
  let ServiceBaseAddress = serviceAddr;
  let DepartmentSession = "DepartmentSession";

  this.HospitalDept = function (success, error) {
    var url = ServiceBaseAddress + "/api/HospitalDept";
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.hospitalDept = function (item, success, error) {
    var url = ServiceBaseAddress + `/api/HospitalDept`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.DeleteHospitalDept = function (id, success, error) {
    var url = ServiceBaseAddress + "/api/HospitalDept/DeleteHospitalDept/" + id;
    TokenClient.Post(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
};

export { HospitalDept }
